module.exports = "/_next/static/images/010c73897f4c9f9bfbdc63ae5b4d6adb-fees-left.jpg";